<template>
    <div id="rav-images-list">
        <transition name="fade">
            <div
                v-show="vSliderVisible"
                id="btn-select-slider-img"
                class="rav-btn-select over-slider"
                @click="onOverSelectImg"
            >Sélectionner</div>
        </transition>
        <div id="dir-loc" class="dir-location">{{ clearedPath }}</div>
        <div id="dir-list">
            <RavDirElt
                v-for="(direlt, index) in dirDirs"
                :key="index"
                :dir="direlt"
                @click-dir="onClickDir"
            />
        </div>
        <div v-show="loading" class="rav-loading">Chargement, merci de patienter...</div>
        <div v-show="!loading" id="img-list">
            <RavImgElt
                v-for="(imgElt, index) in dirImages"
                :key="index"
                :index="index"
                :img="imgElt"
                :url="imgElt.url"
                @select-img="onSelectImg"
                @slide-img-index="onSlideIndex"
                @slide-opened="onOpen"
                @slide-closed="onClose"
            />
        </div>
    </div>
</template>

<script>
import RavDirElt from "./RavDirElt.vue";
import RavImgElt from "./RavImgElt.vue";
import axios from "axios";
import { getHostName } from "../helpers/HttpTools.js";

const urltestmedialib = "https://medialib.gestour.w3b-experience.net/";
const proxyurl = "https://cors-anywhere.herokuapp.com/";
const baseurl =
  document.location.hostname === "localhost"
    ? proxyurl + urltestmedialib
    : "./";
const baseimgurl =
  document.location.hostname === "localhost" ? urltestmedialib : "./";
// console.log("RavImagesList.vue > document.location.hostname = ", document.location.hostname, " / baseurl = ", baseurl);

export default {
  name: "RavImagesList",
  components: {
    RavDirElt,
    RavImgElt
  },
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
        return {
        dirImages: [
            /* {title:'Image 0',url:'https://picsum.photos/200/300?image=0'}, {title:'Image 1',url:'https://picsum.photos/200/300?image=1'} */
        ],
        dirDirs: [
            /* { title: 'Autres', url: './img/Autres', class: 'dir-elt' }, { title: 'Nature', url: './img/Nature', class: 'dir-elt' } */
        ],
        phpScanFile: baseurl + "php/scan.php",
        thumbSize: 180,
        phpSimpleThb: baseimgurl + "php/simplethumb.php",
        rootDirName: "../img",
        baseUrl: null,
        dirName: "",
        loading: false,
        imgIndex: -1,
        vSliderVisible: false
        };
  },
  computed: {
        clearedPath: function() {
        return this.dirName !== this.rootDirName
            ? this.dirName.replace(this.rootDirName, "")
            : "/";
        }
  },
  created: function() {
        // console.log("RavImagesList > this.options = ", this.options);
        this.updateDirView();
  },
  methods: {
    onOverSelectImg: function() {
        // console.log("onOverSelectImg()");
        if(this.imgIndex !== -1)
        {
            this.onSelectImg(this.imgIndex);
        }
    },
    onSelectImg: function(pIndex) {
        console.log("onSelectImg(", pIndex, ")");
        //-- Envoie de l'image à Gestour Catalog
        let urlfull = this.dirImages[pIndex].urlfull;
        this.options.sendImage(urlfull);
        this.$emit("imgselected", urlfull);
    },
    onSelectImg2: function(pUrlFull) {
        //-- Envoie de l'image à Gestour Catalog
        this.options.sendImage(pUrlFull);
        this.$emit("imgselected", pUrlFull);
    },
    onSlideIndex: function(pIndex) {
        //-- Récupère l'index de la slide courante
        this.imgIndex = pIndex;
        console.log("onSlideIndex > ", pIndex, " > this.vSliderVisible = ", this.vSliderVisible);
    },
    onClickDir: function(pUrl) {
        this.updateDirView(pUrl);
    },
    onOpen: function() {
        this.vSliderVisible = true;
    },
    onClose: function() {
        this.vSliderVisible = false;
    },
    updateDirView: function(pPath) {
        if (pPath === undefined) {
            this.dirName = this.rootDirName;
        } else {
            this.dirName = pPath;
        }

        //-- mise à jour pour le chemin pour 'le chemin de fer'
        this.path = this.dirName;

        this.loading = true;

        return axios
            .post(this.phpScanFile, {
            rootdir: this.rootDirName,
            dir: this.dirName,
            rec: 0
            })
            .then(pResponse => {
            // console.log('axios RESPONSE > OK !');

            //-- Liste de répertoires et images
            let listFolders = pResponse.data.items.folders;
            let listFiles = pResponse.data.items.files;

            //-- Images
            let dirImages = [];
            listFiles.forEach(pElt => {
                // console.log( this.phpSimpleThb + "?width=" + this.thumbSize + "&file=" + pElt.path);
                dirImages.push({
                title: pElt.name,
                // url: pElt.path,
                url: pElt.fullpath,
                urlthb:
                    this.phpSimpleThb +
                    "?width=" +
                    this.thumbSize +
                    "&file=" +
                    pElt.path,
                urlfull: pElt.fullpath,
                class: "dir-elt"
                });
            });

            //-- Répertoires
            let dirDirs = [];
            listFolders.forEach(pElt => {
                dirDirs.push({
                title: pElt.name,
                url: pElt.path,
                class:
                    "dir-elt" +
                    (pElt.name.toLowerCase() === "retour" ? " back" : "")
                });
            });

            //-- Affecte la data
            this.dirDirs = dirDirs;
            this.dirImages = dirImages;
            // console.log(JSON.stringify(this.dirDirs), JSON.stringify(this.dirImages));

            this.loading = false;
            })
            .catch(pEvt => {
            console.log(
                "axios RESPONSE > ERROR ! > JSON.stringify(" + pEvt + ")"
            );
            // this.errors.push(e)
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.rav-gallery {
  display: block;
  position: relative;
}

.dir-location {
  color: #000; /*#999;*/
  font-weight: bold;
  margin-bottom: 10px;
  background-color: #e0e0e0;
  line-height: 25px;
  font-size: 20px;
  padding-left: 5px;
}

@keyframes ravAnimLoader {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.rav-loading {
  color: #000;
  font-weight: bold;
  margin-bottom: 10px;
  line-height: 25px;
  font-size: 20px;
  padding-left: 5px;
  opacity: 0;
  animation-name: ravAnimLoader;
  /* animation-delay: 2s; */
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
}

.rav-btn-select {
    color: #fff;
    background-color: #cbcbcb;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #ddd;
    margin: 10px 10px 0px 10px;
    padding: 2px;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;

    &:hover {
        border: 1px solid #aaa;
        box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
        color: #000;
        background-color: #e0e0e0;
    }

    &.over-slider{
        z-index: 10000;
        width: 160px;
        height: 35px;
        line-height: 35px;
        position: absolute;
        bottom: 50px;
        margin-left: 50%;
        transform: translateX(-50%);
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
